import Footer from "../../../../component/footer";
import Navbar from "../../../../component/navbar";

const Announce1 = () => {
  return (
    <>
      <Navbar />

      <div className="container max-w-5xl mx-auto ">
        <div className="h-screen min-w-screen flex flex-col ">
          <div
            onClick={() => {
              window.open(
                "/FLEX/flex1/1728972224-TOFVVKYrgaIKIjqYyghx-2.pdf",
                "_blank"
              );
            }}
            className="bg-gradient-to-bl from-[#9e76b4] to-[#5eafd2] hover:shadow-xl 
          px-5 py-5 rounded-lg text-white font-semibold text-3xl my-10 cursor-pointer"
          >
            ประกาศ: หลักเกณฑ์และวิธีการที่เกี่ยวกับการเบิก สวัสดิการด้านสุขภาพ
            พ.ศ. 2567
          </div>

          <div className="mx-auto pb-20">
            <img
              src="/FLEX/all-flex-scaled.jpg"
              className="object-contain"
              alt=""
            />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};
export default Announce1;
